import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import { HttpUtils } from '../../../../../common/http/http-utils';
import { HttpClient } from '@angular/common/http';

export class OrganizationModel {
  name: string;
  fullName: string;
  description: string;
  user: {
    username: string,
    password: string
  };
  objectId: string;
}

@Injectable()
export class OrganizationService {
    private orgApi: string = '/hybridity/api/vcd/inventory/query?entityType=org&id=';
    private value: any;
    // stores all org from data store
    private _organizations$: Subject<OrganizationModel[]>;
    // stores all org fetched from DB
    private dataStore: {
      organizations: OrganizationModel[]
    };
    // stores selected org from detail view
    private currentOrganization: OrganizationModel = null;

    constructor(public http: HttpClient) {
      this.dataStore = { organizations: [] };
      this._organizations$ = <Subject<OrganizationModel[]>>new Subject();
    }

    getCurrentOrganization(orgId) {
        return this.currentOrganization;
    }
    setCurrentOrganization(org) {
        this.currentOrganization = org;
    }

    // returns all org observer, it notifies if org array is changed
    get organizations() {
      return this._organizations$.asObservable();
    }


    /*
     * load all orgs from DB by calling REST api and store it in data store
     */

    getOrganizations() {
        return this.http
        .get(HttpUtils.getBaseUrl() + this.orgApi)
    }

    /*
        getOrganizationDetails(orgId: string) {
        return this.http
        .get(HttpUtils.getBaseUrl() + this.orgApi + orgId)
        }
    */

    /*
     * Temperory hack until '/hybridity/api/vcd/inventory/query?entityType=org&id=<org id>' is supported by backend
     */
  getOrganizationDetails(orgId: string) {
      return this.http
      .get(HttpUtils.getBaseUrl() + '/hybridity/api/vcd/inventory/query?entityType=org')
      .map(
        function(res:any) {
          let orgsArray = res;
          let org;
          for (let x = 0; x < orgsArray.length; x++) {
            if (orgsArray[x].organization === orgId) {
              org = orgsArray[x];
              break;
            }
          }
          return this.value = org;
        }
      );
  }

    createOrg(obj) {
        return this.http
        .post(HttpUtils.getBaseUrl() + '/hybridity/api/orgs', JSON.stringify(obj))
        .map(
            res => this.value = res
        );
    }

    updateOrg(obj, orgId) {
        return this.http
        .put(HttpUtils.getBaseUrl() + '/hybridity/api/orgs/' + orgId, JSON.stringify(obj))
        .map(
            res => this.value = res
        );
    }

    deleteOrg(id: string) {
        return this.http
        .delete(HttpUtils.getBaseUrl() + '/hybridity/api/orgs/' + id)
        .map(
            res => this.value = res
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/organization/organization.service.ts